export const MAX_MEETING_TIME_PER_MEETING = 30;
export const MAX_MEETING_TIME_TOTAL = 300;

// File size limits (in bytes)
export const MAX_RESUME_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
export const MAX_IMAGE_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

// Helper functions to get file size limits in MB
export const MAX_RESUME_FILE_SIZE_MB = MAX_RESUME_FILE_SIZE / (1024 * 1024);
export const MAX_IMAGE_FILE_SIZE_MB = MAX_IMAGE_FILE_SIZE / (1024 * 1024);
